import Http from '@nal/helpers/http';
import { Observable } from 'rxjs';
import { BaseService } from '@nal/services/Base.service';
import { User } from '@nal/models/User.model';
import { map } from 'rxjs/operators';
import _ from 'lodash';

export class UserService extends BaseService {
    constructor() {
        super('users');
    }

    me(): Observable<User> {
        return Http.get('users/login').pipe(map(({ data }) => new User(data)));
    }

    changePassword(payload: any): Observable<any> {
        return Http.post('auth/reset-password', payload);
    }

    index(
        page: number = 0,
        perPage: number = 10,
        filters: any = {},
        includes: string[] = [],
        sorts: any = { id: 'DESC' }
    ): Observable<any> {
        return super.index(page, perPage, filters, includes, sorts).pipe(
            map((response) => {
                const data = _.map(_.get(response, 'data.data.data', []), (item) => new User(item));
                const total = _.get(response, 'data.data.total', data.length);

                return {
                    data,
                    total,
                };
            })
        );
    }
}
